import React from 'react';

/**
 * Page representing an agent's Documents.
 */
export const Documents = () => {
  return (
    <div>
      <h2>Documents</h2>
    </div>
  );
};
